import { render } from "./ProximaTurma.vue?vue&type=template&id=b3711186"
import script from "./ProximaTurma.vue?vue&type=script&lang=js"
export * from "./ProximaTurma.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__